import React from 'react';
import {
  Box,
  IconButton,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerBody,
  DrawerCloseButton,
  Tooltip,
  BoxProps,
  useBreakpointValue,
  useDisclosure,
} from '@chakra-ui/react';
import { faArrowFromRight, faArrowToRight } from '@fortawesome/pro-regular-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IAsideCollapse {
  children?: React.ReactNode;
  containerProps?: BoxProps;
  label?: string;
  isOpen?: boolean;
  onToggle?: () => void;
  desktopProps?: BoxProps;
  mobileProps?: BoxProps;
}

export const AsideCollapse = (props: IAsideCollapse) => {
  const { children, desktopProps, mobileProps } = props;

  const isLargeScreen = useBreakpointValue({ base: false, lg: true });

  const { isOpen, onOpen, onClose } = useDisclosure();
  const onOpenRef = React.useRef<HTMLButtonElement>(null);
  const onCloseRef = React.useRef<HTMLButtonElement>(null);

  const label = isOpen ? 'Close details' : 'Open details';
  const icon = isOpen ? faArrowToRight : faArrowFromRight;

  if (isLargeScreen) {
    return (
      <Box
        as="aside"
        width={{ lg: '20rem', xl: '24rem', '2xl': '28rem', '3xl': '32rem' }}
        pt={1}
        pb={12}
        flexShrink={0}
        bgColor={'chakra-subtle-bg'}
        borderLeftWidth={1}
        height={{ md: '100%' }}
        overflowY={{ md: 'auto' }}
        className="nav-scrollbar"
        {...desktopProps}
      >
        {children}
      </Box>
    );
  }

  return (
    <>
      <Tooltip hasArrow placement="left" label={label}>
        <IconButton
          aria-label={label}
          onClick={onOpen}
          ref={onCloseRef}
          variant="outline"
          colorScheme="gray"
          position="fixed"
          top={{ base: 2, md: 4 }}
          right={0}
          borderRightRadius={0}
          borderRightWidth={0}
          bgColor="chakra-subtle-bg"
          icon={<FontAwesomeIcon icon={icon} />}
        />
      </Tooltip>

      <Drawer
        isOpen={isOpen}
        onClose={onClose}
        size="sm"
        placement="right"
        initialFocusRef={onOpenRef}
        finalFocusRef={onCloseRef}
      >
        <DrawerOverlay />

        <DrawerContent maxWidth={{ base: 'calc(100vw - 2.5rem)', sm: '28rem' }}>
          <DrawerCloseButton bgColor={'chakra-body-bg'} top={3} right={'100%'} mr={1} zIndex={1} />

          <DrawerBody as="aside" px={0} pt={2} className="nav-scrollbar" {...mobileProps}>
            {children}
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};
